import { OPTION_CHAIN_SNAPSHOTS_POLLING_INTERVAL } from "~/v2/constants";
import { queryKeys } from "../queryKeys";
import {
  type GetOptionSnapshotsResponse,
  getOptionChainSnapshots,
} from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOptionChainSnapshots = ({
  underlyingSymbol,
  expirationDate,
  isCrypto,
  options,
}: {
  underlyingSymbol?: string;
  expirationDate: string;
  isCrypto: boolean;
  options?: QueryOptions<GetOptionSnapshotsResponse | undefined>;
}) =>
  useRequest(
    queryKeys.options.chainSnapshots(underlyingSymbol, expirationDate),
    () =>
      getOptionChainSnapshots({
        underlying_symbol: underlyingSymbol ?? "",
        expiration_date: expirationDate,
      }),
    {
      refetchInterval: OPTION_CHAIN_SNAPSHOTS_POLLING_INTERVAL,
      staleTime: OPTION_CHAIN_SNAPSHOTS_POLLING_INTERVAL,
      ...options,
      enabled:
        !isCrypto &&
        !!underlyingSymbol &&
        !!expirationDate &&
        (options?.enabled ?? true),
    },
  );

export default useGetOptionChainSnapshots;
